export const scrollTop = () => {
    window.scrollTo({ top: 0 });
};